import { render, staticRenderFns } from "./liabilities-section.vue?vue&type=template&id=2bd209b2&scoped=true"
import script from "./liabilities-section.vue?vue&type=script&lang=ts"
export * from "./liabilities-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd209b2",
  null
  
)

export default component.exports